import createCache from '@emotion/cache';

export default function createEmotionCache(nonce?: string) {
    const insertionPoint = document.getElementById('emotion-insertion-point') as HTMLElement;
    console.log('💥 CSP nonce in Emotion cache:', nonce);
    console.log('🎯 Insertion point:', insertionPoint);

    return createCache({
        key: 'mui',
        insertionPoint: insertionPoint ?? undefined,
        nonce,
    });
}